import React from 'react'

export const SynonymIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" {...props}>
      <g fill={props.color} clipPath="url(#clip0_309_11832)">
        <path d="m17.473 3.228-2.272-2.227a2.927 2.927 0 0 0-2.226-1H4.613c-1.59-.045-2.954 1.364-2.954 2.955v12.363c0 .637.273 1.273.727 1.682.546.546 2.363 2.318 2.363 2.318a2.306 2.306 0 0 0 1.636.682h9.634a2.328 2.328 0 0 0 2.318-2.318V5.319a2.654 2.654 0 0 0-.864-2.09ZM2.477 2.956c0-1.137.954-2.137 2.09-2.137h3.454v3.546c0 .272.318.5.545.363 0 .091 1.727-1.681 1.773-1.681l1.636 1.636c.227.273.727.045.681-.273V.865c1.273-.137 2.5.818 2.454 2.136v12.364c0 .818-.681 1.5-1.5 1.5H3.978c-.818 0-1.5-.682-1.5-1.5V2.955Zm15.087 14.727c0 .818-.681 1.5-1.5 1.5H6.432c-.41 0-.773-.182-1.091-.455l-1.136-1.136h9.407c1.227 0 2.317-1.045 2.317-2.318V2.819c.682.682 1.682 1.41 1.636 2.5v12.364Z" />
        <path d="M11.5 7.294H6.25V8h5.25v-.706ZM8.5 8v6h.8V8h-.8Z" />
      </g>
      <defs>
        <clipPath id="clip0_309_11832">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
